import { CapturedPayload } from '../models/CapturedPayload';
import { LogMessage } from '../models/ILogger';
import { ITransporter } from '../models/ITransporter';
import { LogLevel } from '../models/LogLevel';
import { TransportTemplate } from './TransportTemplate';

/**
 * Base Transporter implementation
 */
export abstract class AbstractTransporter<T = LogMessage> implements ITransporter<T> {
    template: TransportTemplate<T>;
    constructor(template: TransportTemplate<T>) {
        this.template = template;
    }

    write(payload: CapturedPayload, level?: LogLevel) {
        const templatedPayload = this.template(payload);
        this.doWrite(templatedPayload, level);
    }

    abstract doWrite(payload: T, level?: LogLevel): void;
}
